<template>
    <b-modal :visible="visible" no-close-on-backdrop no-close-on-esc centered body-class="providers-list-body">
        <div slot="modal-header" class="w-100">
            <h5>Select Providers
                <button type="button" class="close"
                        @click.prevent="closeModal()">
                    <span aria-hidden="true">&times;</span></button>
            </h5>
        </div>
            <b-form-group>
                <b-form-radio-group v-model="filterByProvider"
                                    :options="filterOptions"
                                    stacked
                                    name="filterOption">
                </b-form-radio-group>
            </b-form-group>
            <transition name="slide">
              <b-form-group v-show="filterByProvider">
                <b-form-checkbox
                    v-model="allSelected"
                    @change="toggleAll"
                >
                  {{ allSelected ? 'Un-select All' : 'Select All' }}
                </b-form-checkbox>
                <b-form-checkbox
                    v-for="provider in providers" :key="provider.providerId"
                    :id="'provider-' + provider.providerId"
                    class="ml-4"
                    stacked
                    v-model="selectionIds"
                    :value="provider.providerId"
                >{{ provider.displayName }}
                </b-form-checkbox>
              </b-form-group>
            </transition>
        <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-orange float-right" @click.prevent="saveProviderIds()">Save</button>
            <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
        </div>
    </b-modal>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'provider-select',

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      selectedProviderIds: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        selectionIds: _.clone(this.selectedProviderIds),
        filterByProvider: this.selectedProviderIds.length > 0,
        allSelected: false,
        filterOptions: [
          { text: 'All Providers', value: false },
          { text: 'Select Providers', value: true }
        ]
      }
    },

    watch: {
      selectedProviderIds (newValue) {
        this.selectionIds = _.clone(newValue)
        if (newValue.length === 0) {
          this.allSelected = false
        } else if (newValue === this.allProviderIds) {
          this.allSelected = true
        } else {
          this.allSelected = false
        }
      }
    },

    computed: {
      providers () {
        return this.$store.organization.providers
      },
      allProviderIds () {
        return this.providers.map(aProvider => {
          return aProvider.providerId
        })
      }
    },

    methods: {
      toggleAll (checked) {
        this.selectionIds = checked ? this.allProviderIds : []
      },
      saveProviderIds () {
        if (this.filterByProvider) {
          this.$emit('saveProviderIds', this.selectionIds)
        } else {
          this.selectionIds = []
          this.$emit('saveProviderIds', [])
        }
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>
